














export default {
  name: "Layout",
  props:['title']
}
